<template>
	<p class="menu-item theme-select">
		<span class="theme-btn" v-for="(theme, index) in themes" :key="index" :style="{backgroundColor: theme['--primary-color']}" @click="setTheme(index)"></span>
	</p>
</template>

<script>
	export default{
		name: 'ThemeSelect',
		data: () => ({
			themes: [
				{
					'--primary-color': '#45AE49',
					'--primary-light': '#A3E9A6',
					'--primary-dark': '#2D9D32'
				},
				{
					'--primary-color': '#F63E3E',
					'--primary-light': '#FFA9A9',
					'--primary-dark': '#EE1010'
				},
				{
					'--primary-color': '#111111',
					'--primary-light': '#5F5F5F',
					'--primary-dark': '#000'
				},
				{
					'--primary-color': '#007BF7',
					'--primary-light': '#6CB7FF',
					'--primary-dark': '#0059B1'
				},
				{
					'--primary-color': '#415284',
					'--primary-light': '#AABEF1',
					'--primary-dark': '#21346A'
				}
			]
		}),
		mounted(){
			let i = localStorage.getItem('shoppy_theme')
			if(!i) return
			try{
				this.setTheme(parseInt(i))
			}catch(e){ console.log('Could of set theme!') }
		},
		methods: {
			setTheme(i){
				let theme = this.themes[i]
				localStorage.setItem('shoppy_theme', i)
				for(let p in theme){
					document.documentElement.style.setProperty(p, theme[p])
				}
			}
		}
	}
</script>

<style>
.theme-select{
	justify-content: space-evenly;
}
.theme-select:hover{
	background-color: transparent;
}
.theme-btn{
	height: 20px;
	width: 20px;
	border-radius: 50%;
	transition: transform 0.33s;
}
.theme-btn:hover{
	transform: scale(1.1);
}
</style>